import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

// import dynamic from 'next/dynamic';

import { getQueryClient } from './get-client-query';

// const ReactQueryDevtools = dynamic(async () => (await import('@tanstack/react-query-devtools')).ReactQueryDevtools);

export function ReactQueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [queryClient] = useState(t1);
  let t2;
  if ($[1] !== children || $[2] !== queryClient) {
    t2 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[1] = children;
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}